import React from 'react';
import './App.css';
import Main from "./pages/Main/Main";
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import Policy from "./pages/Policy/Policy";
import {CONTACTS, MAIN, PRIVACY} from "./utils/constants/routes";
import Contacts from "./pages/Contacts/Contacts";

function App() {
  return (
            <Router>
                <Routes>
                    <Route path={'/'}>
                        <Route path={MAIN} element={<Main/>}/>
                        <Route path={PRIVACY} element={<Policy/>}/>
                        <Route path={CONTACTS} element={<Contacts/>}/>
                        <Route path="/*" element={<Navigate to={MAIN}/>} />
                        <Route path="/" element={<Navigate to={MAIN}/>} />
                    </Route>
                </Routes>
            </Router>
  );
}

export default App;
